import { ReactComponent as FinnBlack } from '../../../../assets/icons/FINN-black.svg';

export { FinnBlack };
